"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const MobileDeviceGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "MOBILE-DEVICE-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    d: "M10.5 20.75a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "evenodd",
    d: "M16 0a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zM6 19.5h12V21a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm0-1h12V3a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2z",
    clipRule: "evenodd"
  }));
};
MobileDeviceGraphicIcon.displayName = "MobileDeviceGraphicIcon";
MobileDeviceGraphicIcon.iconName = "MobileDevice";
export default MobileDeviceGraphicIcon;